import _ from 'lodash'
import React from 'react'

import { SheetManager } from 'browser/components/atomic-elements/atoms/sheet/sheet-manager'
import { SamlSettingsDetails } from 'browser/components/domains/firm/saml-settings-details'

export const SamlSettings: React.FC = (props: any) => {
  return (
    <div className='grid-block'>
      <div className='grid-block vertical c-appBody'>
        <SheetManager className='grid-block vertical'>
          <SamlSettingsDetails />
        </SheetManager>
      </div>
    </div>
  )
}
